import { useQuery } from '@tanstack/react-query'
import { getTipHistory } from 'api/worker'
import { useAuthContext } from 'components/auth'
import { QueryFnData, QueryOptions } from 'queries/types'
import { workerKeys } from './keys'

export function useTipHistory<TData = QueryFnData<typeof getTipHistory>>(
  filters: { workerId?: number; shiftId?: number },
  options: QueryOptions<typeof getTipHistory, TData> = {}
) {
  const { company } = useAuthContext()
  const hasFilter = Object.values(filters).some(Boolean)

  return useQuery({
    ...options,
    enabled: Boolean(hasFilter && company?.id && (options.enabled ?? true)),
    queryKey: workerKeys.tipHistory(filters),
    queryFn: async () => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }

      if (!hasFilter) {
        throw new Error('Worker ID or shift ID is required')
      }

      return getTipHistory({ companyId: company.id, filters })
    },
  })
}
